import "../Styles/Home.css";
import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export const Home = () => {
  const url = [
    "https://drive.google.com/file/d/1jL8I7kNPkzn5cJszqo0fy7YCOWu0qrHr/view?usp=sharing",
    "http://www.linkedin.com/in/aditya-nj2",
    "https://github.com/onlyaditya",
  ];

  const handleLink = (address) => {
    window.open(address);
  };

  return (
    <>
      <div className="home" id="home">
        <img src="/MyPic.jpg" alt="" />
        <div className="name">
          <div className="intro">
            <div> Hi! 👋 {"\u00A0"}</div>
            <div className="name"> I am Aditya Kumar</div>
          </div>

          <p className="intro2">A Full Stack Web developer</p>
          <div className="home-contact">
            <div className="email">
              <EmailIcon fontSize="medium" sx={{ color: "white" }}/>
              <div>onlyaditya001@gmail.com</div>
            </div>
            <div className="phone">
              <CallIcon fontSize="medium" sx={{ color: "white" }} />
              <div>+91 7012423588</div>
            </div>
          </div>
          <div className="home-icons">
            <Button
              variant="outlined"
              endIcon={<DownloadIcon />}
              sx={{ color: "white" }}
              onClick={()=>{handleLink(url[0])}}
            >
              Resume
            </Button>
            <GitHubIcon onClick={()=>{handleLink(url[2])}} fontSize="large" sx={{ color: "white" }} className="git" />
            <LinkedInIcon onClick={()=>{handleLink(url[1])}} fontSize="large" sx={{ color: "white" }} className="link" />
          </div>
        </div>
      </div>
    </>
  );
};
